import Themeable from "vuetify/lib/mixins/themeable";

export default {
	name: "KTrucksMapSidebarMixin",

	mixins: [ Themeable ],

	props: { loading: Boolean },

	computed: {
		sidebarClasses() {
			return {
				"k-trucks-map-sidebar fill-height py-0": true,
				"white": !this.isDark,
				"grey darken-4": this.isDark
			};
		}
	},

	watch: {
		show() {
			this.$nextTick( () => this.$gmapDefaultResizeBus.$emit( "resize" ) );
		}
	}
};
